import apiClient from './apiClient'


const getSocialMedias = (tenant) => {
  return apiClient.get(`/${tenant}/SocialMedia`)
}


export default {
  getSocialMedias
}
